/* Copyright (c) 2012-2022 The ANTLR Project. All rights reserved.
 * Use of this file is governed by the BSD 3-clause license that
 * can be found in the LICENSE.txt file in the project root.
 */
import { default as atn } from './atn/index.js';
import { default as dfa } from './dfa/index.js';
import { default as context } from './context/index.js';
import { default as misc } from './misc/index.js';
import { default as tree } from './tree/index.js';
import { default as error } from './error/index.js';
import { default as CharStreams } from './CharStreams.js';
import { default as Utils } from './utils/index.js';

import Token from './Token.js';
import CommonToken from './CommonToken.js';
import InputStream from './InputStream.js';
import CharStream from './InputStream.js';
import FileStream from './FileStream.js';
import CommonTokenStream from './CommonTokenStream.js';
import Lexer from './Lexer.js';
import Parser from './Parser.js';

import RuleContext from './context/RuleContext.js';
import ParserRuleContext from './context/ParserRuleContext.js';
import ATN from './atn/ATN.js';
import PredictionMode from './atn/PredictionMode.js';
import LL1Analyzer from './atn/LL1Analyzer.js';
import ATNDeserializer from './atn/ATNDeserializer.js';
import LexerATNSimulator from './atn/LexerATNSimulator.js';
import ParserATNSimulator from './atn/ParserATNSimulator.js';
import PredictionContextCache from './atn/PredictionContextCache.js';
import DFA from "./dfa/DFA.js";
import RecognitionException from "./error/RecognitionException.js";
import FailedPredicateException from "./error/FailedPredicateException.js";
import NoViableAltException from "./error/NoViableAltException.js";
import BailErrorStrategy from "./error/BailErrorStrategy.js";
import Interval from './misc/Interval.js';
import IntervalSet from './misc/IntervalSet.js';
import ParseTreeListener from "./tree/ParseTreeListener.js";
import ParseTreeVisitor from "./tree/ParseTreeVisitor.js";
import ParseTreeWalker from "./tree/ParseTreeWalker.js";
import ErrorListener from "./error/ErrorListener.js"
import DiagnosticErrorListener from "./error/DiagnosticErrorListener.js"
import RuleNode from "./tree/RuleNode.js"
import TerminalNode from "./tree/TerminalNode.js"
import arrayToString from "./utils/arrayToString.js"

export default {
    atn, dfa, context, misc, tree, error, Token, CommonToken, CharStreams, CharStream, InputStream, FileStream, CommonTokenStream, Lexer, Parser,
    ParserRuleContext, Interval, IntervalSet, LL1Analyzer, Utils
}

export {
    Token, CommonToken, CharStreams, CharStream, InputStream, FileStream, CommonTokenStream, Lexer, Parser,
    RuleNode, TerminalNode, ParseTreeWalker, RuleContext, ParserRuleContext, Interval, IntervalSet,
    PredictionMode, LL1Analyzer, ParseTreeListener, ParseTreeVisitor, ATN, ATNDeserializer, PredictionContextCache, LexerATNSimulator, ParserATNSimulator, DFA,
    RecognitionException, NoViableAltException, FailedPredicateException, ErrorListener, DiagnosticErrorListener, BailErrorStrategy,
    arrayToString
}

/* eslint no-unused-vars: [ "off"] */
// need to import unused to force loading
import StringHashCode from './utils/stringHashCode.js';
import CodePointAt from './polyfills/codepointat.js';
import FromCodePoint from './polyfills/fromcodepoint.js';
